import { render, staticRenderFns } from "./TrimVideo.vue?vue&type=template&id=1c861ef9&scoped=true&"
import script from "./TrimVideo.vue?vue&type=script&lang=js&"
export * from "./TrimVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c861ef9",
  null
  
)

export default component.exports